/*===================================================================
=             ROOT REDUCER                            =
====================================================================*/
/**
 * Combine all reducers into a single root reducer.
 */

import { combineReducers } from "redux";
import { IStateAuthReducer } from "../features/auth/redux/auth.reducer";
import authReducer from "../features/auth/redux/auth.reducer";
import filterReducer, { IFilterState } from "../common/analysis/filter/redux/filter.reducer";

// Reducers

/*======== TYPES =========== */
export interface IRootState {
  auth: IStateAuthReducer;
  filterChart: IFilterState // Replace 'any' with the actual type if available
}

/*======== ROOT REDUCER =========== */
const appReducer = combineReducers({
  auth: authReducer,
  filterChart: filterReducer 
});

export const rootReducer = (state: any, action: never) => {
  return appReducer(state, action);
};

export default rootReducer;
